export const drawerWidth = 150;
export const minWindowWidth = 730;

export const PPage = 50;